import React from 'react';
import { Typography, Box } from '@mui/material';
import { useParams } from 'react-router-dom';
const LeadDetail = () => {
  const { id } = useParams();
  return (
<Box p={3}><Typography variant="h2">Lead Detail: {id}</Typography></Box>
  );
};
export default LeadDetail;
